import { Content } from "../types";

const homePageUrl = process.env.PUBLIC_URL;

const asset = (url: string) => homePageUrl + url;

const getContent = (lang: "fr"): Content => {
  return {
    idApplication: "3434ce2f-49d6-4228-8468-ee32fb1c5e97",
    shouldStoreInteractionAndObjectiveInSuspendData: true,
    title: '<span style="white-space:nowrap;">Ouvrir les possibles</span><span> sur le handicap !</span>',
    language: "fr",
    backgroundMedia: {
      type: "image",
      url: asset("/assets/content/background/home-bg.png"),
      mobileUrl: asset("/assets/content/background/home-bg-mobile.png"),
    },
    footerLeft: [],
    footerRight: [],
    footerBackground: "#FFFFFF",
    logo: asset("/assets/branding/Logo.png"),
    boxList: [
      /*---------------------------BOX1-------------------------*/
      {
        id: "box1",
        title: "L'engagement CEGID",
        type: "menu",
        order: 0,
        boxConnectionList: ["right"],
        primaryColor: "#FFFFFF",
        secondaryColor: "#59372F",
        boxBackground: "#FF5C35",
        background: {
          type: "image",
          url: asset("/assets/content/background/home-bg.png"),
        },
        menuBackground: "#FFFFFF",
        titleColor: "#0046FE",
        boxList: [
          {
            id: "box1-1",
            title: "MISSION HANDICAP",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                embedNavigation: true,
                type: "multimedia1",
                title: "Mot de la Mission Handicap",
                background: "#dae8ff",
                id: "box1-1-1",
                text: ` 
                <p class="big-text">Bienvenue dans la Digibox !</p>            
                <p>Depuis plus de 10 ans, Cegid s’engage en faveur de l’inclusion des personnes en situation de handicap.</p>
<p>Aujourd’hui, notre taux d’emploi est de 4,30% : une belle réussite, supérieure à la moyenne des entreprises de notre secteur d’activité.
Au-delà des chiffres, nous avons accompagné de nombreux aménagements, formé ou sensibilisé les équipes, travaillé avec des
partenaires du secteur protégé,...</p>
<p>Cet engagement doit continuer à être partagé par chacun-e d’entre nous. La Digibox est là pour vous permettre de diffuser nos
valeurs et de les mettre en pratique.</p>
<p>Grâce à cet outil, vous pourrez en savoir plus sur le handicap, connaître les bonnes pratiques à adopter et avoir à votre disposition
des ressources utiles.</p>
<p>A vous de l’explorer, de la partager, d’en parler !</p>
<p> <strong>Bonne visite,<br>
La Mission Handicap</strong></p>
              `,
                media: {
                  type: "image",
                  url: asset("/assets/content/background/case1/audrey.png"),
                },
              },
            ],
          },
          {
            id: "box1-1-2",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case1/picto_2_sous_case_1.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box1-1-3",
            title: "Nos principales mesures",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                title: "Nos principales mesures",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                type: "multimedia2",
                background: "#FFFFFF",
                id: "box1-1-3-1",
                text: `<p class="big-text"><strong>Attirer les talents</strong></pCet>       
                <ul>
                  <li>Egalit&eacute; de traitement et non-discrimination</li>
                  <li>Appui de la Mission Handicap sur demande du service Talent Acquisition ou des managers pour certaines situations individuelles</li>
                  <li>Objectif annuel de recrutements de travailleur-euses handicap&eacute;-es</li>
                  <li>Actions sp&eacute;cifiques de recrutement avec des partenaires de l&rsquo;emploi, des organismes de formation, des &eacute;coles, des associations</li>
                  <li>Pr&eacute;sentation de la politique handicap et des ressources &agrave; disposition sur le sujet pour toute nouvelle int&eacute;gration</li>
                  <li>Rendez-vous d&rsquo;accueil avec la Mission Handicap pour chaque nouvel-le arrivant-e en situation de handicap</li>
                </ul>
                
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/01.jpg"),
                },
              },
              {
                embedNavigation: true,
                type: "multimedia2",
                title: "Nos principales mesures",
                background: "#FFFFFF",
                id: "box1-1-3-2",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                text: ` <p class="big-text"><strong>Accompagner les parcours</strong></p>               
                <ul >
                  <li>Suivi des personnes en situation de handicap par la Mission Handicap et Diversité et l’Infirmerie</li>
                  <li>Aide à la constitution d’un dossier RQTH par la Mission Handicap et Diversité ou la/le Correspondant-e Handicap de proximité</li>
                  <li>Etude de toute demande d’aménagement de poste sur préconisations médicales</li>
                  <li>Possibilité d’aménagement d’horaires pour tout personne bénéficiaire d’une RQTH ou proche aidant-e (ascendant-es, descendant-es, conjoint-e)</li>
                  <li>Jours prévus pour les démarches : 1 jour de congé fractionnable en 2 demi journées pour les démarches liées à l’obtention d’une RQTH et 2 jours de congés fractionnables en demi journées pour le suivi administratif ou médical pour les bénéficiaires d’une RQTH ou en tant que proches aidant-es (sur présentation de justificatifs)</li>             
                  <li>Possibilité d’accompagnement externe sur demande (médiation)</li>
                </ul>
                
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/02.jpg"),
                },
              },
              {
                embedNavigation: true,
                type: "multimedia2",
                title: "Nos principales mesures",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#FFFFFF",
                id: "box1-1-3-3",
                text: ` <p class="big-text"><strong>Changer les regards</strong></p>               
                <ul>
                  <li>Intervention de la Mission Handicap Diversité pour des sessions de sensibilisation ou de formation sur demande des managers ou de la DRH, parmi celles disponibles dans le catalogue</li>
                  <li>Sessions annuelles de formation pour l’ensemble des managers</li>
                  <li>Evènements réguliers de sensibilisation pour l’ensemble des collaborateur-ices</li>
                  <li>Diffusion d’une newsletter tous les deux mois par la Mission Handicap Diversité</li>
                  <li>Diffusion de communications régulières</li>
                </ul>
                
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/03.jpg"),
                },
              },
              {
                embedNavigation: true,
                type: "multimedia2",
                title: "Nos principales mesures",
                background: "#FFFFFF",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                id: "box1-1-3-4",
                text: ` <p  class="big-text"><strong>Diffuser l’engagement</strong></p>
                <ul>
                  <li>Recours fréquent à des ESAT et EA</li>
                  <li>Mise à disposition et alimentation d’un catalogue de prestataires du secteur adapté et protégé</li>
                  <li>Participation à des clubs et réseaux d’entreprises autour du handicap</li>
                  <li>Participation à des évènements ou forums externes sur le handicap</li>
                </ul>
                
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/04.jpg"),
                },
              },
            ],
          },
          {
            id: "box1-1-4",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case1/picto_4_sous_case_1.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box1-1-5",
            title: "Notre accord",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                type: "resourceList",
                id: "box1-1-5-1",
                background: {
                  type: "image",
                  url: asset("/assets/content/background/background_ressources_bleu.png"),
                  mobileUrl: asset("/assets/content/background/background_ressources_bleu-mobile.png"),
                },
                title: "Notre accord",
                resourceList: [
                  {
                    id: "ACCORD_HANDICAP_CEGID_2018-2020",
                    url: asset("/assets/resources/ACCORD_HANDICAP_CEGID_2018-2020.pdf"),
                    name: "Pour voir notre accord, cliquez ici",
                    type: "pdf",
                  },
                ],
              },
            ],
          },
          {
            id: "box1-1-6",
            type: "empty",
            order: 0,
            title: "",
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case1/picto_6_sous_case_1.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
        ],
      },
      /*---------------------------BOX2-------------------------*/
      {
        id: "box2",
        type: "menu",
        title: "S'informer",
        order: 1,
        boxBackground: "#FF5C35",
        boxConnectionList: ["down"],
        primaryColor: "#FFFFFF",
        secondaryColor: "#59372F",
        menuBackground: "#FFFFFF",
        titleColor: "#0046FE",
        boxList: [
          {
            id: "box2-1",
            type: "content",
            order: 0,
            title: "La définition du handicap",
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                embedNavigation: true,
                type: "multimedia1",
                title: "La définition du handicap",
                background: "#FFFFFF",
                id: "box2-1-1",
                text: `                
                <p class="colored-block"><strong>L&rsquo;origine du mot handicap</strong></p>

                <p>Le terme <strong>« handicap »</strong> provient de la formule anglaise <strong>« hand in cap »</strong> (la main dans le chapeau), expression utilisée dans un <strong>jeu de hasard</strong> pratiqué au XVIème siècle en Grande-Bretagne et par la suite dans certains sports.<br> <br>En course hippique par exemple, le but était « d’handicaper » les concurrents, en rajoutant au départ de la course des poids supplémentaires sur les chevaux les plus forts. La fonction d’un « handicapeur » consistait alors à assurer à tou·te·s <strong>une égalité des chances</strong> jusqu’à l’accès à la ligne.</p>
                <p class="source">Source : https://handincap.wordpress.com/2013/03/27/la-main-dans-le-chapeau/</p>
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey.png"),
                },
              },
              {
                embedNavigation: true,
                type: "multimedia1",
                title: "La définition du handicap",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#FFFFFF",
                id: "box2-1-2",
                text: `

                <p class="colored-block"><strong>Quelques définitions</strong></p>
                <p><strong>Le handicap</strong> désigne l’incapacité ou la limitation d’une personne à agir ou interagir dans son environnement en raison de déficiences ou altérations mentales, psychiques, physiques ou sensorielles. </p>              
                <p>Juridiquement, <strong>le handicap</strong> se définit comme <i>« Toute limitation d'activité ou restriction de participation à la vie en société subie dans son environnement par une personne en raison d'une altération substantielle, durable ou définitive d'une ou plusieurs fonctions physiques, sensorielles, mentales, cognitives ou psychiques, d'un polyhandicap ou d'un trouble de santé invalidant. »</i><br> <p class="law-text">Article L.114 du Code de l’action sociale et des familles</p>
                                
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey2.png"),
                },
              },
              {
                type: "multimedia1",
                title: "La définition du handicap",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#FFFFFF",
                id: "box2-1-3",
                text: `
                <p class="colored-block"><strong>Quelques définitions</strong></p>
              <p>Un·e travailleur·euse handicapé·e est défini·e dans le code du travail (Article L.5213-1 ) comme <strong>« toute personne dont les possibilités d'obtenir ou de conserver un emploi sont effectivement réduites par suite de l'altération d'une ou plusieurs fonctions physique, sensorielle, mentale ou psychique.»</strong></p>
                <p>Les travailleur·euse·s handicapé·e·s peuvent bénéficier d’une <stron>Reconnaissance de la Qualité de Travailleur Handicapé (RQTH)</stron>. Il s’agit d’une décision administrative permettant de bénéficier d’aides spécifiques. </p>
                <p>Bien que non définie par la loi, la notion de <strong>« personne en situation de handicap »</strong> est souvent utilisée. 
                Elle précise que le handicap n’est pas une caractéristique de la personne mais <strong>la conséquence d’un environnement ou d’une situation non adaptée à elle.</strong><br>
                Exemple : Une personne en fauteuil roulant est en situation de handicap face à un escalier mais ne l’est pas sur d’autres situations professionnelles (animation d’une réunion...) </p>
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey.png"),
                },
              },
            ],
          },
          {
            id: "box2-2",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case2/picto_2_sous_case_2.png"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box2-3",
            type: "content",
            order: 0,
            title: "Les différents types de handicap",
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                type: "fakeQuestion",
                title: "Les différents types de handicap",
                background: "#fff",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                id: "box2-3-Q1",
                question: "Combien y-a t-il de catégories de handicap ? ",
                answerBlockBackground: {
                  type: "image",
                  url: asset("/assets/content/background/background_answer_block.jpg"),
                },
                answerList: [
                  {
                    text: "2",
                  },
                  {
                    text: "6",
                  },
                  {
                    text: "10",
                  },
                ],
              },
              {
                id: "box2-3-Debrief-Q1",
                type: "image",
                title: "Les différents types de handicap",
                background: "#fff",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                image: {
                  type: "image",
                  url: asset("/assets/images/question1-debrief1.png"),
                  mobileUrl: asset("/assets/images/question1-debrief1-mobile.png"),
                },
                embedNavigation: true,
              },
              {
                type: "fakeQuestion",
                title: "Les différents types de handicap",
                background: "#fff",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                embedNavigation: true,
                id: "box2-3-Q2",
                question: "La majorité des personnes en situation de handicap se déplace en fauteuil roulant.",
                answerBlockBackground: {
                  type: "image",
                  url: asset("/assets/content/background/background_answer_block.jpg"),
                },
                answerList: [
                  {
                    text: "Vrai",
                  },
                  {
                    text: "Faux",
                  },
                ],
              },
              {
                id: "box2-3-Debrief-Q2",
                type: "image",
                title: "Les différents types de handicap",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#fff",
                image: {
                  type: "image",
                  url: asset("/assets/images/question2-debrief2.png"),
                  mobileUrl: asset("/assets/images/question2-debrief2-mobile.png"),
                },
                embedNavigation: true,
              },
              {
                type: "fakeQuestion",
                background: "#fff",
                title: "Les différents types de handicap",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                id: "box2-2-Q3",
                question:
                  "Sur 100 personnes en situation de handicap, quelle est la proportion de personnes dont le handicap n’est pas visible ?",
                answerBlockBackground: {
                  type: "image",
                  url: asset("/assets/content/background/background_answer_block.jpg"),
                },
                answerList: [
                  {
                    text: "25%",
                  },
                  {
                    text: "45%",
                  },
                  {
                    text: "65%",
                  },
                  {
                    text: "85%",
                  },
                ],
              },
              {
                id: "box2-2-Debrief-Q3",
                type: "multimedia1",
                background: "#fff",
                title: "Les différents types de handicap",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey3.png"),
                },
                text: `
                <p class="colored-block"><strong>85 % des handicaps ne sont pas visibles</strong></p>
                <p>Un <strong>handicap invisible</strong> est un handicap qui n’est pas détectable sauf si la personne vous en informe. <br> Exemples :</p>
                <ul>
                <li>Les <strong>troubles psychiques ou cognitifs </strong></li>
                <li>Les <strong>troubles physiques ou sensoriels discrets</strong>, tels que le daltonisme, les hernies discales, ou bien les souffles au coeur... </li>
                <li>Les <strong>troubles liés à certaines maladies invalidantes</strong> comme la sclérose en plaques, le diabète, le VIH, et toutes les maladies provoquant des douleurs chroniques.</li>
                </ul>
                <p>Porter une <strong>attention particulière</strong> et une <strong>attitude empathique aux personnes avec un handicap invisible est important</strong> : ce n’est pas parce qu’on ne voit pas le handicap que les contraintes ou les difficultés sont moins importantes !</p>
                <p class="source">Sources :<br>
                https://www.handinorme.com/accessibilite-handicap/45-le-handicap-invisible-comprendre-les-differents-handicaps<br>
                https://lexpansion.lexpress.fr/actualite-economique/handicap-en-entreprise-il-faut-tout-changer_1947250.html<br>
                https://www.talenteo.fr/handicap-invisible-travail-007/<br>
                </p>
                `,
              },
            ],
          },
          {
            id: "box2-4",
            type: "empty",
            order: 0,
            title: "",
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case2/picto_4_sous_case_2.png"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box2-5",
            type: "content",
            order: 0,
            title: "Le handicap au travail",
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                type: "multimedia1",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#fff",
                title: "Le handicap au travail",
                id: "box2-5-1",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey3.png"),
                },
                text: `
                <p class="colored-block"><strong>Pourquoi il est important d’agir ?</strong></p>
                <p><strong style="color:#0046FE;">Chômage</strong></p>
                <p>Les travailleur·euse·s handicapé·e·s sont <strong>2 fois plus</strong> touché.e.s par le chômage que les autres.
                Ils ou elles ont <strong>trois fois moins de chances</strong> de trouver un emploi que les candidat·e·s valides ayant les mêmes caractéristiques. </p>
                <p><strong style="color:#0046FE;">Discrimination</strong></p>
                <p>Depuis maintenant trois années consécutives, le handicap constitue le <strong>premier motif</strong> de saisine du Défenseur Des Droits et la <strong>première cause</strong> de discrimination devant celui de l’origine. <br>
                (chiffres 2019)</p>
                <p><strong style="color:#0046FE;">Précarité</strong></p>
                <p>Selon le baromètre IFOP-APF France Handicap de la confiance de 2019, environ <strong>2 millions</strong> de personnes en situation de handicap vivent sous le seuil de pauvreté et <strong>82 %</strong> déclarent s'en sortir difficilement avec les ressources de leur foyer. </p>
               `,
              },
              {
                id: "box2-5-2",
                type: "multimedia2",
                title: "Le handicap au travail",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#ffffff",
                text: `
                <p class="colored-block">
                <strong>Cadre juridique</strong>
                </p>
                <p>Il existe un certain nombre de dispositifs légaux en faveur de l’intégration et de l’accompagnement des personnes en situation de handicap dans le cadre de leur emploi. 
                </p>
                <p>Depuis <strong>la loi pour l'égalité des droits et des chances, la participation et la citoyenneté des personnes handicapées</strong> du 11 février 2005 :
                </p>
                <ul>
                <li>Incitation à développer une politique d’intégration des personnes handicapées pour les entreprises </li>
                <li>Dispositifs et aides personnalisées pour les salarié·e·s ou demandeur·euse·s d’emploi handicapé·e·s (RQTH, contrats spécifiques d’insertion...)</li>
              
                </ul>
                             
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/cadre_bon_a_savoir.png"),
                },
                embedNavigation: true,
              },
            ],
          },
          {
            id: "box2-6",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case2/picto_6_sous_case_2.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
        ],
      },
      /*---------------------------BOX3-------------------------*/
      {
        id: "box3",
        type: "empty",
        order: 2,
        boxBackground: {
          type: "image",
          url: asset("/assets/content/background/case3/picto_case_3.png"),
        },
        primaryColor: "#FFFFFF",
        secondaryColor: "#59372F",
      },

      /*---------------------------BOX4-------------------------*/
      {
        id: "box4",
        type: "content",
        order: 7,
        primaryColor: "#0046FE",
        secondaryColor: "#59372F",
        title: "contacts",
        boxBackground: "#FFFFFF",
        icon: asset("/assets/content/background/case4/ico-108-about-us-b.png"),
        activityList: [
          {
            id: "box4-1",
            type: "resourceList",
            background: {
              type: "image",
              url: asset("/assets/content/background/background_ressources_bleu.png"),
              mobileUrl: asset("/assets/content/background/background_ressources_bleu-mobile.png"),
            },
            title: "CONTACTS",
            resourceList: [
              {
                id: "contacts",
                url: asset("/assets/resources/Trombinoscope-MH.pdf"),
                name: "Visualiser et télécharger le trombinoscope ici",
                type: "pdf",
              },
            ],
            embedNavigation: true,
          },
        ],
      },
      /*---------------------------BOX5-------------------------*/

      {
        id: "box5",
        title: "Changer de regard",
        type: "menu",
        order: 2,
        boxConnectionList: ["right"],
        primaryColor: "#FFFFFF",
        secondaryColor: "#59372F",
        boxBackground: "#FF5C35",
        background: {
          type: "image",
          url: asset("/assets/content/background/home-bg.png"),
        },
        menuBackground: "#FFFFFF",
        titleColor: "#0046FE",
        boxList: [
          {
            id: "box5-1",
            title: "Dépasser les stéréotypes et les préjugés",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                type: "fakeQuestion",
                background: "#fff",
                title: "Dépasser les stéréotypes et les préjugés",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                id: "box5-1-Q1",
                question: "Toutes les personnes en situation de handicap ont besoin d’un aménagement de poste ?",
                answerBlockBackground: {
                  type: "image",
                  url: asset("/assets/content/background/background_answer_block.jpg"),
                },
                answerList: [
                  {
                    text: "Vrai",
                  },
                  {
                    text: "Faux",
                  },
                ],
              },
              {
                id: "box5-1-Debrief-Q1",
                type: "multimedia1",
                title: "Dépasser les stéréotypes et les préjugés",
                background: "#FFFFFF",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey2.png"),
                },
                text: `
               <p class="colored-block">FAUX ! Pas toujours besoin d’aménager le poste de travail.</p>
               <p>Dans 90 % des cas, l’embauche d’un·e travailleur·euse handicapé·e n’entraîne pas d’aménagement de poste. </p>
               <p>
               Les aménagements nécessaires ne sont, quant à eux, pas forcément coûteux : au-delà du matériel, ils peuvent porter, par exemple, sur  l’organisation du temps de  travail.</p>
               `,
                embedNavigation: true,
              },
              {
                id: "box5-1-2",
                type: "multimedia1",
                title: "Dépasser les stéréotypes et les préjugés",
                background: "#FFFFFF",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey.png"),
                },
                text: `
                <p class="colored-block">Quand les stéréotypes et préjugés peuvent être un obstacle !</p>
                <p class="uppercase"><strong style="color:#0046FE;">Stéréotypes</strong></p>
                <p>Les stéréotypes sont des croyances partagées concernant les caractéristiques, attributs ou comportements attribués à des groupes de personnes.  </p>
                <p class="uppercase"><strong style="color:#0046FE;">Préjugés</strong></p>
                <p>Les préjugés sont des opinions envers des individus ou des attitudes comportant une dimension évaluative (souvent défavorable) à l’égard d’un groupe social donné. </p>
                <p><strong>Ainsi nous avons tou·te·s  des stéréotypes pouvant nous conduire à avoir des préjugés. L’important est d’en avoir conscience et de les <b></b>neutraliser</b>. </strong></p>
                <p class="source">Le saviez-vous ? Pour fonctionner normalement, notre cerveau, dès notre plus jeune âge, catégorise les informations. C’est cette catégorisation qui est à l’origine des stéréotypes et eux-mêmes à l’origine de nos préjugés. </p>
               `,
                embedNavigation: true,
              },
              {
                id: "box5-1-3",
                type: "image",
                title: "Dépasser les stéréotypes et les préjugés",
                background: "#FFF",
                image: {
                  type: "image",
                  url: asset("/assets/content/background/case5/schema_1.png"),
                  mobileUrl: asset("/assets/content/background/case5/schema_1-mobile.png"),
                },
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
              },
              {
                id: "box5-1-4",
                embedNavigation: true,
                type: "image",
                title: "Dépasser les stéréotypes et les préjugés",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#FFF",
                image: {
                  type: "image",
                  url: asset("/assets/content/background/case5/schema_2.png"),
                  mobileUrl: asset("/assets/content/background/case5/schema_2-mobile.png"),
                },
              },
            ],
          },
          {
            id: "box5-2",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case5/picto_1_sous_case_5.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box5-3",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case5/picto_2_sous_case_5.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box5-4",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case5/picto_3_sous_case_5.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box5-5",
            title: "Permettre l'autonomie",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                type: "fakeQuestion",
                title: "Permettre l'autonomie",
                background: "#fff",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                embedNavigation: true,
                id: "box5-5-Q1",
                question:
                  "Toutes les personnes en situation de handicap ont-elles une reconnaissance de la qualité de travailleur handicapé (RQTH) ?",
                answerBlockBackground: {
                  type: "image",
                  url: asset("/assets/content/background/background_answer_block.jpg"),
                },
                answerList: [
                  {
                    text: "Oui",
                  },
                  {
                    text: "Non",
                  },
                ],
              },
              {
                id: "box5-5-Debrief-Q1",
                type: "multimedia1",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                title: "Permettre l'autonomie",
                background: "#FFFFFF",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey3.png"),
                },
                text: `<p class="colored-block">Eh non, toutes les personnes n’ont pas forcément une RQTH</p>
<p>De <strong>peur d’être mal intégré·e·s, jugé·e·s ou stigmatisé·e·s</strong>, un certain nombre de salarié·e·s en situation de handicap ne parlent pas de leur handicap au travail. Cela les conduit à travailler sans aide qui pourraient les soulager dans leur vie quotidienne et professionnelle (aménagement du poste de travail, des horaires…).</p>
<p><strong style="color:#0046FE;">Le saviez-vous ?</strong></p>
<p>Une personne qui a un handicap ou une problématique de santé n’a aucune obligation d’en parler à son employeur. 
Seul le médecin du travail peut définir l’aptitude totale, partielle ou l’inaptitude d’un·e salarié·e à un poste de travail.</p></div>

               `,
                embedNavigation: true,
              },
              {
                id: "box5-5-2",
                type: "multimedia1",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                title: "Permettre l'autonomie",
                background: "#FFFFFF",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey3.png"),
                },
                text: `
<p class=colored-block>Le saviez-vous ? </p>
<p><strong>80 % des réclamations</strong> des travailleur·euse·s handicapé·e·s auprès du Défenseur Des Droits portent sur <strong>l'évolution professionnelle</strong> (promotion, formation, salaire,…). </p>
<p>Il existe un cadre juridique relatif à la non discrimination auquel est assujettie toute entreprise.<strong> Le handicap est reconnu comme un critère de discrimination.</strong></p>
               `,
                embedNavigation: true,
              },
              {
                id: "box5-5-3",
                type: "multimedia1",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#ffffff",
                title: "Permettre l'autonomie",
                text: `<p class="colored-block">La discrimination est un délit</p>
              <p>D'un point de vue juridique, la discrimination se définit comme « à situation comparable, une différence de traitement sur la base d’un critère prohibé et dans un domaine visé par la loi. »  Article 225-1 du Code pénal</p>
              <p>Discriminer peut-être un acte <strong>conscient</strong> ou <strong>inconscient</strong> qui  peut résulter <strong>des stéréotypes et des préjugés.</strong> </p>   
                <p><strong>Rappelez-vous, les travailleur·euse·s présentant un handicap sont aussi compétent.e.s que ceux qui n’en ont pas !</strong></p> 
              `,
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey2.png"),
                },
                embedNavigation: true,
              },
              {
                type: "fakeQuestion",
                background: "#fff",
                title: "Permettre l'autonomie",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                embedNavigation: true,
                id: "box5-5-Q2",
                question: "A votre avis, quelle est la proportion de handicaps qui surviennent au cours de la vie ?",
                answerBlockBackground: {
                  type: "image",
                  url: asset("/assets/content/background/background_answer_block.jpg"),
                },
                answerList: [
                  {
                    text: "30%",
                  },
                  {
                    text: "63%",
                  },
                  {
                    text: "85%",
                  },
                ],
              },
              {
                id: "box5-5-Debrief-Q2",
                type: "multimedia1",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                title: "Permettre l'autonomie",
                embedNavigation: true,
                background: "#FFFFFF",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey3.png"),
                },
                text: `
               <p class="colored-block"><strong>85 % des handicaps surviennent au cours de la vie ! </strong></p>           
                <p><strong style="color:#0046FE;">Le maintien dans l’emploi est une nécessité car nous sommes tou.te.s concerné.e.s !</strong><br>
                85 % des handicaps apparaissent au cours de la vie et font suite à des maladies déclarées après la naissance, à des accidents subis au cours de la vie ou au vieillissement. <br>
                1 personne sur 2 sera confrontée au cours de sa vie à une situation de handicap, <strong>de manière ponctuelle ou définitive.</strong></p>
             <p><strong style="color:#0046FE;">De quoi parle-t-on ?</strong><br>
             Le <strong>maintien de l’emploi</strong> fait référence à l’action <strong>d’adapter les conditions de travail</strong> d’un·e salarié·e présentant une inaptitude ou un risque d’inaptitude à son poste de travail, afin de lui permettre de <strong>conserver son emploi durablement.</strong></p>
             <p><strong style="color:#0046FE;">Comment fait-on ?</strong><br>
             Il existe des solutions, le plus souvent convenues lors de la <strong>signature d’accord handicap</strong> au sein des entreprises. Elles ont pour objectif d’accompagner les personnes concernées par une difficulté d’exercer leur activité. </p>
               `,
              },
            ],
          },
          {
            id: "box5-6",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case5/picto_4_sous_case_5.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
        ],
      },
      /*---------------------------BOX6-------------------------*/

      {
        id: "box6",
        type: "menu",
        order: 3,
        title: "Agir au quotidien",
        boxConnectionList: ["down"],
        primaryColor: "#FFFFFF",
        secondaryColor: "#59372F",
        boxBackground: "#FF5C35",
        background: {
          type: "image",
          url: asset("/assets/content/background/home-bg.png"),
        },
        menuBackground: "#FFFFFF",
        titleColor: "#0046FE",
        boxList: [
          {
            id: "box6-1",
            title: "Faciliter l'intégration",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                type: "fakeQuestion",
                title: "Faciliter l'intégration",
                background: "#fff",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                id: "box6-1-Q1",
                question: "Il existe un label visant à reconnaître qu’une entreprise est handi-accueillante",
                answerBlockBackground: {
                  type: "image",
                  url: asset("/assets/content/background/background_answer_block.jpg"),
                },
                answerList: [
                  {
                    text: "Vrai",
                  },
                  {
                    text: "Faux",
                  },
                ],
              },
              {
                id: "box6-1-Debrief-Q1",
                type: "multimedia1",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                title: "Faciliter l'intégration",
                embedNavigation: true,
                background: "#FFFFFF",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey2.png"),
                },
                text: `
<p class="colored-block">Aujourd’hui il n’existe pas de label</p>
<p>Toutefois dans le cadre de l’incitation des entreprises à développer un processus d’intégration pérenne, <strong>LA LOI PACTE</strong> propose de créer un <strong>label entreprise handi-accueillante</strong>. </p>
                <p><strong>Bien intégrer une personne en situation de handicap</strong><br>
                Accueillir un·e collaborateur·rice, collègue handicapé·e au sein de l’équipe peut susciter des interrogations et/ou la crainte de commettre des maladresses.
                </p>
                <p>Lors d’un premier contact avec une personne en situation de handicap, il est important de faire preuve de bienveillance et de patience, et d’écouter la personne pour comprendre son état, si elle souhaite partager ces informations. Le dialogue est donc toujours à privilégier tout en respectant l’intimité de l’autre.
                </p>
                <p>Il faut tenter de mettre de côté ses propres préjugés et être ouvert à la discussion face à la personne en situation de handicap.
                </p>
               `,
              },
            ],
          },
          {
            id: "box6-2",
            type: "empty",
            order: 0,
            primaryColor: "#0046FE",
            secondaryColor: "#59372F",
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case6/picto_1_sous_case_6.jpg"),
            },
          },
          {
            id: "box6-3",
            title: "S’adapter aux différents types de handicap",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                id: "box6-3-1",
                type: "image",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                title: "S’adapter à l’autre",
                background: "#fff",
                image: {
                  type: "image",
                  url: asset("/assets/content/background/case6/sous_case_2.2.png"),
                  mobileUrl: asset("/assets/content/background/case6/sous_case_2.2-mobile.png"),
                },
                embedNavigation: true,
              },
              {
                id: "box6-3-2",
                type: "image",
                title: "S’adapter à l’autre",
                embedNavigation: true,
                background: "#fff",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                image: {
                  type: "image",
                  url: asset("/assets/content/background/case6/sous_case_2.2.2.png"),
                  mobileUrl: asset("/assets/content/background/case6/sous_case_2.2.2-mobile.png"),
                },
              },
            ],
          },
          {
            id: "box6-4",
            type: "empty",
            order: 0,
            primaryColor: "#0046FE",
            secondaryColor: "#59372F",
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case6/picto_2_sous_case_6.jpg"),
            },
          },
          {
            id: "box6-5",
            title: "Être inclusif·ve au quotidien",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                id: "box6-5-1",
                background: "#fff",
                type: "multimedia1",
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                title: "Développer de bons réflexes",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey.png"),
                },
                text: `
               <p class="colored-block">Pour un·une manager·euse </p>
              <ul>
              <li>S’assurer de la mise en œuvre des aménagements lorsqu’ils sont nécessaires</li>
              <li>Veiller à rendre accessibles les consignes et les outils de travail </li>
              <li>Mettre à disposition les documents nécessaires à une bonne compréhension de l’entreprise, du poste, des missions et objectifs</li>
              <li>Dialoguer régulièrement avec la personne concernée, en respectant son intimité et la confidentialité</li>
              <li>Assurer un suivi lors des entretiens (fin de la période d’essai, développement des compétences…) </li>
              <li>Solliciter le Mission Handicap Cegid pour avoir des conseils </li>
              </ul>
              <p class="center-text"><strong>La Mission Handicap est présente pour vous appuyer dans l’accompagnement des collaborateur·rice·s en situation de handicap. </strong></p>
               `,
                embedNavigation: true,
              },
              {
                id: "box6-5-2",
                type: "multimedia1",
                title: "Développer de bons réflexes",
                embedNavigation: true,
                isNeededForCompletion: true,
                tracking: {
                  completeCondition: "open",
                  successCondition: "open",
                },
                background: "#fff",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey2.png"),
                },
                text: `
                <p class="colored-block">Pour les collègues</p>
                <ul>
                <li>Comme pour toute personne, bienveillance et écoute sont les maître-mots ! </li>
                <li>Signaler sa disponibilité auprès de la personne concernée. Si elle en ressent le besoin et exprime sa demande, répondre à ses questions sans porter de jugement. </li>
              <li>Ne pas tomber dans un excès de compassion ou d’empathie, ni dans l’excès inverse en ignorant totalement le handicap. </li>
              <li>Respecter l’intimité et la vie privée en ne posant pas de questions intrusives. </li>
              <li>Si l’on se questionne sur le handicap, ne pas hésiter à faire des recherches de son côté pour mieux comprendre. </li>
                </ul>
              
               `,
              },
            ],
          },
          {
            id: "box6-6",
            type: "empty",
            order: 0,
            primaryColor: "#0046FE",
            secondaryColor: "#59372F",
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case6/picto_3_sous_case_6.png"),
            },
          },
        ],
      },

      /*---------------------------BOX7-------------------------*/

      {
        id: "box7",
        type: "menu",
        order: 6,
        title: "FOCUS RQTH",
        primaryColor: "#0046FE",
        secondaryColor: "#59372F",
        boxBackground: "#FFFFFF",
        icon: asset("/assets/content/background/case7/ico-183-contact-us-b.png"),
        menuBackground: "#FFFFFF",
        boxConnectionList: ["up"],
        boxList: [
          {
            id: "box7-1",
            title: "Qu’est-ce que c’est ?",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                id: "box7-1-1",
                type: "multimedia1",
                title: "Qu’est-ce que c’est ?",
                embedNavigation: true,
                background: "#fff",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey.png"),
                },
                text: `
                <p class="colored-block">La « RQTH » : c’est quoi ? Comment l’obtenir ? </p>
                <p><strong style="color:#0046FE;">La reconnaissance de la qualité de travailleur·euse handicapé·e est : </strong></p>
            <ul>
            <li><strong>Pour des salarié·e·s :</strong> avec des restrictions dans l’exercice de leur emploi en raison de problèmes de santé </li>
            <li><strong>Confidentielle :</strong> l’employeur n’est pas mis au courant du handicap sans l’accord du ou de la concerné·e.</li>
            <li><strong>A soumettre à :</strong>  La Maison Départementale des Personnes Handicapées (MDPH) de votre domicile.</li>
            <li>D’une <strong>durée de 10 ans ou sans limitation</strong></li>
            </ul>
            <p><strong style="color:#0046FE;">Elle permet :</strong></p>
            <ul>
            <li>De bénéficier de tous les accompagnements prévus par la loi ou l’accord handicap de l’entreprise</li>
            <li>De <strong>légitimer les difficultés rencontrées au travail</strong></li>
            </ul>
               `,
              },
              {
                id: "box7-1-2",
                type: "multimedia1",
                title: "Qu’est-ce que c’est ?",
                embedNavigation: true,
                background: "#fff",
                media: {
                  type: "image",
                  url: asset("/assets/images/audrey2.png"),
                },
                text: `
                <p class="colored-block">La « RQTH » à Cegid ?</p>
                <p>Pour accompagner les travailleur·euse·s en situation de handicap, la <strong>Mission Handicap de Cegid</strong> a mis en place un réseau de <strong>« Correspondant·e·s Handicap »</strong>  au sein des différents sites de l’entreprise : leur rôle est notamment d’accompagner les personnes concernées. </p>
              <p>La <strong>Mission Handicap</strong> est également en mesure de vous fournir les <strong>documents à remplir afin de soumettre une demande de RQTH</strong>, dont une partie médicale devra être remplie par un médecin. </p>
               `,
              },
            ],
          },
          {
            id: "box7-1-2",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case7/picto_2_sous_case_1.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box7-1-5",
            title: "Documents utiles",
            type: "content",
            order: 0,
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                type: "resourceList",
                background: {
                  type: "image",
                  url: asset("/assets/content/background/background_ressources_bleu.png"),
                  mobileUrl: asset("/assets/content/background/background_ressources_bleu-mobile.png"),
                },
                id: "box7-1-5-1",
                title: "Documents utiles",
                resourceList: [
                  {
                    id: "RQTH",
                    url: asset("/assets/resources/Constituer-Un-Dossier-RQTH.pdf"),
                    name: "Télécharger le document sur la RQTH ici",
                    type: "pdf",
                  },
                ],
              },
            ],
          },
        ],
      },
      /*---------------------------BOX8-------------------------*/

      {
        id: "box8",
        type: "menu",
        order: 5,
        title: "Ressources",
        boxConnectionList: ["left"],
        primaryColor: "#0046FE",
        secondaryColor: "#59372F",
        icon: asset("/assets/content/background/case8/ico-90-tool-case-b.png"),
        boxBackground: "#FFFFFF",
        menuBackground: "#FFFFFF",
        boxList: [
          {
            id: "box8-1",
            type: "content",
            order: 5,
            title: "Manager",
            boxConnectionList: ["left"],
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                id: "box8-1",
                title: "Manager",
                type: "resourceList",
                background: {
                  type: "image",
                  url: asset("/assets/content/background/background_ressources_bleu.png"),
                  mobileUrl: asset("/assets/content/background/background_ressources_bleu-mobile.png"),
                },
                tracking: {
                  completeCondition: "open",
                },
                resourceList: [
                  {
                    id: "ProcessManager",
                    url: asset("/assets/content/background/case8/Manager/ProcessManager.pdf"),
                    name: "Process Manager",
                    type: "pdf",
                  },
                  {
                    id: "Process-Toutes-Situations",
                    url: asset("/assets/content/background/case8/Manager/Process-Toutes-Situations.pdf"),
                    name: "Process Toutes Situations",
                    type: "pdf",
                  },
                  {
                    id: "Guides_Ressources",
                    url: asset("/assets/content/background/case8/Manager/Guides_Ressources.pdf"),
                    name: "Guides Ressources",
                    type: "pdf",
                  },
                  {
                    id: "Devenir_Correspondant-Handicap",
                    url: asset("/assets/content/background/case8/Manager/Devenir_Correspondant-Handicap.pdf"),
                    name: "Devenir Correspondant Handicap",
                    type: "pdf",
                  },
                  {
                    id: "CataloguePrestatairesSecteurProtege",
                    url: asset("/assets/content/background/case8/Manager/Catalogue_prestataires_secteur_protege.pdf"),
                    name: "Catalogue Prestataires Secteur Protégé",
                    type: "pdf",
                  },
                  {
                    id: "Catalogue-Sensibilisations-formations",
                    url: asset("/assets/content/background/case8/Manager/Catalogue-Sensibilisations-formations.pdf"),
                    name: "Catalogue Sensibilisations formations",
                    type: "pdf",
                  },
                ],
              },
            ],
          },
          {
            id: "box8-2",
            type: "empty",
            order: 0,
            boxBackground: {
              type: "image",
              url: asset("/assets/content/background/case8/picto_1_sous_case_2.jpg"),
            },
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
          },
          {
            id: "box8-3",
            type: "content",
            order: 5,
            title: "Collaborateur",
            boxConnectionList: ["left"],
            primaryColor: "#FFFFFF",
            secondaryColor: "#59372F",
            boxBackground: "#FF5C35",
            activityList: [
              {
                id: "box8-1",
                title: "Collaborateur",
                type: "resourceList",
                background: {
                  type: "image",
                  url: asset("/assets/content/background/background_ressources_bleu.png"),
                  mobileUrl: asset("/assets/content/background/background_ressources_bleu-mobile.png"),
                },
                tracking: {
                  completeCondition: "open",
                },
                resourceList: [
                  {
                    id: "ProcessSituationHandicap2",
                    url: asset("/assets/content/background/case8/Collaborateur/ProcessSituationHandicap.pdf"),
                    name: "Process Situation Handicap",
                    type: "pdf",
                  },
                  {
                    id: "Process-Toutes-Situations2",
                    url: asset("/assets/content/background/case8/Collaborateur/Process-Toutes-Situations.pdf"),
                    name: "Process Toutes Situations",
                    type: "pdf",
                  },
                  {
                    id: "Guides_Ressources2",
                    url: asset("/assets/content/background/case8/Collaborateur/Guides_Ressources.pdf"),
                    name: "Guides Ressources",
                    type: "pdf",
                  },
                  {
                    id: "Devenir_Correspondant-Handicap2",
                    url: asset("/assets/content/background/case8/Collaborateur/Devenir_Correspondant-Handicap.pdf"),
                    name: "Devenir Correspondant Handicap",
                    type: "pdf",
                  },
                  {
                    id: "CataloguePrestatairesSecteurProtégé2",
                    url: asset(
                      "/assets/content/background/case8/Collaborateur/Catalogue_prestataires_secteur_protege.pdf",
                    ),
                    name: "Catalogue Prestataires Secteur Protégé",
                    type: "pdf",
                  },
                ],
              },
            ],
          },
        ],
      },
      /*---------------------------BOX9-------------------------*/
      {
        id: "box9",
        type: "content",
        lockedByCompletionOfBoxList: [
          "box1-1",
          "box1-1-3",
          "box2-1",
          "box2-3",
          "box2-5",
          "box5-1",
          "box5-5",
          "box6-1",
          "box6-3",
          "box6-5",
        ],
        fullscreen: true,
        title: "Devenir incollable",
        primaryColor: "#FFFFFF",
        secondaryColor: "#59372F",
        boxConnectionList: ["left"],
        boxBackground: "#FF5C35",
        icon: asset("/assets/content/background/case9/ico-195-marketing-academy-b.png"),
        objective: {
          successOnSucessOfInteractionList: ["quiz-final"],
        },
        order: 4,
        activityList: [
          {
            type: "realQuiz",
            id: "quiz-final",
            title: "Devenir incollable",
            isNeededForCompletion: true,
            embedNavigation: true,
            background: {
              type: "image",
              url: asset("/assets/content/background/case9/background_quiz.png"),
              mobileUrl: asset("/assets/content/background/case9/background_quiz_mobile.png"),
            },
            tracking: {
              successCondition: "success",
            },
            validatingThreshold: 4,
            quiz: {
              id: "quiz-final",
              questionList: [
                {
                  type: "multipleAnswer",
                  showEachAnswerResults: true,
                  id: "q0",
                  instructions: "Plusieurs réponses possibles",
                  question: "1. Sélectionnez les éléments ci-dessous qui sont des typologies de handicap ",
                  answerList: [
                    {
                      id: "q0-a0",
                      text: "Le handicap psychique",
                      valid: true,
                    },
                    {
                      id: "q0-a1",
                      text: "Le handicap moteur",
                      valid: true,
                    },
                    {
                      id: "q0-a2",
                      text: "Le handicap sensoriel",
                      valid: true,
                    },
                    {
                      id: "q0-a3",
                      text: "Les maladies invalidantes",
                      valid: true,
                    },
                  ],
                },
                {
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  id: "q1",
                  instructions: "Une seule réponse possible",
                  question:
                    "2. Quel est le pourcentage de travailleur.euse.s handicapé.e.s qui ont besoin d’un aménagement de poste ?",
                  answerList: [
                    {
                      id: "q1-a1",
                      text: "15%",
                      valid: true,
                    },
                    {
                      id: "q1-a2",
                      text: "43%",
                      valid: false,
                    },
                    {
                      id: "q1-a0",
                      text: "95%",
                      valid: false,
                    },
                  ],
                },
                {
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  id: "q2",
                  instructions: "Une seule réponse possible",
                  question: "3. Quel est le pourcentage de personnes qui naissent avec un handicap ?",
                  answerList: [
                    {
                      id: "q2-a0",
                      text: "40%",
                      valid: false,
                    },
                    {
                      id: "q2-a1",
                      text: "25%",
                      valid: false,
                    },
                    {
                      id: "q2-a2",
                      text: "15%",
                      valid: true,
                    },
                  ],
                },
                {
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  id: "q3",
                  instructions: "Vrai ou Faux ?",
                  question:
                    "4. La proportion des personnes ayant un handicap visible est plus importante que celles ayant un handicap invisible",
                  answerList: [
                    {
                      id: "q3-a0",
                      text: "Vrai",
                      valid: false,
                    },
                    {
                      id: "q3-a1",
                      text: "Faux",
                      valid: true,
                    },
                  ],
                },
                {
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  id: "q4",
                  instructions: "Vrai ou Faux ?",
                  question: "5. Le handicap fait partie des critères de discrimination",
                  answerList: [
                    {
                      id: "q4-a0",
                      text: "Vrai",
                      valid: true,
                    },
                    {
                      id: "q4-a1",
                      text: "Faux",
                      valid: false,
                    },
                  ],
                },
                {
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  id: "q5",
                  instructions: "Une seule réponse possible",
                  question: "6. Que signifie RQTH ?",
                  answerList: [
                    {
                      id: "q5-a0",
                      text: "Reconnaissance de la Qualité de Travailleur Handicapé ",
                      valid: true,
                    },
                    {
                      id: "q5-a1",
                      text: "Reconnaissance et Qualification au Travail du Handicap ",
                      valid: false,
                    },
                  ],
                },
                {
                  id: "q6",
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  instructions: "Vrai ou Faux ?",
                  question:
                    "7. Avoir une RQTH permet aux salarié.e.s concerné.e.s de bénéficier si besoin d’aménagements de poste ? ",
                  answerList: [
                    {
                      id: "q6-a0",
                      text: "Vrai",
                      valid: true,
                    },
                    {
                      id: "q6-a1",
                      text: "Faux",
                      valid: false,
                    },
                  ],
                },
                {
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  id: "q7",
                  instructions: "Une seule réponse possible",
                  question:
                    "8. Pour obtenir ou renouveler sa RQTH, combien de jours autorisés d’absence sont prévus par CEGID ?",
                  answerList: [
                    {
                      id: "q7-a0",
                      text: "2 jours",
                      valid: false,
                    },
                    {
                      id: "q7-a1",
                      text: "2 demi-journées",
                      valid: true,
                    },
                    {
                      id: "q7-a2",
                      text: "1 demi-journée",
                      valid: false,
                    },
                  ],
                },
                {
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  id: "q8",
                  instructions: "Une seule réponse possible",
                  question: "9. Quel est le taux d’emploi de personnes en situation de handicap pour CEGID en 2020 ?",
                  answerList: [
                    {
                      id: "q7-a0",
                      text: "2,2 %",
                      valid: false,
                    },
                    {
                      id: "q7-a1",
                      text: "3,5 %",
                      valid: false,
                    },
                    {
                      id: "q7-a2",
                      text: "4,3 %",
                      valid: true,
                    },
                  ],
                },
                {
                  type: "singleAnswer",
                  showEachAnswerResults: true,
                  id: "q9",
                  instructions: "Une seule réponse possible",
                  question:
                    "10. Combien de personnes en situation de handicap font partie des effectifs de CEGID en fin d’année 2020 ?",
                  answerList: [
                    {
                      id: "q7-a0",
                      text: "34",
                      valid: false,
                    },
                    {
                      id: "q7-a2",
                      text: "65",
                      valid: false,
                    },
                    {
                      id: "q7-a1",
                      text: "90",
                      valid: true,
                    },
                  ],
                },
              ],
            },
          },
          {
            id: "resultat-quiz-final",
            relatedQuiz: "quiz-final",
            embedNavigation: true,
            background: {
              type: "image",
              url: asset("/assets/content/background/case9/background_quiz.png"),
              mobileUrl: asset("/assets/content/background/case9/background_quiz_mobile.png"),
            },
            type: "quizResult",
            scoreExpression: "percentage",
            fail: {
              text:
                "Désolé, vous n'avez pas bien répondu. Retentez le quiz ou revoyez certaines parties qui ne sont pas claires pour vous.",
            },
            success: {
              text: "Félicitations ! Votre module de sensibilisation est désormais terminé.",
            },
          },
        ],
      },
    ],
  };
};

export default getContent("fr");
